// @ts-nocheck
// ====== Export XLSX ======
// Lazy-loaded modulo per esportare clienti, accessi e scadenze in un singolo
// workbook XLSX multi-foglio. Si attiva con il bottone "⬇ XLSX" della vista
// Clienti (sempre admin).

let _xlsxLib = null;
async function getXlsx() {
  if (_xlsxLib) return _xlsxLib;
  _xlsxLib = await import('xlsx');
  return _xlsxLib;
}

function sanitizeSheetName(s) {
  // Excel: max 31 char, no [ ] : * ? / \
  return (
    String(s || 'Sheet')
      .replace(/[\\/?*[\]:]/g, ' ')
      .slice(0, 31)
      .trim() || 'Sheet'
  );
}

async function exportClientiXlsx() {
  if (!isAdmin()) return;
  try {
    const XLSX = await getXlsx();
    const clients = (state?.clients || []).slice().sort((a, b) => a.nome.localeCompare(b.nome));
    const wb = XLSX.utils.book_new();

    // ===== Foglio 1: Clienti =====
    const cliRows = clients.map((c) => ({
      Nome: c.nome,
      CPL: c.cpl || '',
      PM1: c.pm1 || '',
      PM2: c.pm2 || '',
      'Service Line Ref': c.serviceLineRef || '',
      'Tenant ID': c.tenantId || '',
      Perimetri: (c.perimetri || []).join(', '),
      Tecnici: (c.tecnici || []).join(', '),
      Ruolo: c.ruolo || '',
      'Tipo accesso': c.assegnazionePerenne || '',
      Directory: c.directory || '',
      PIM: c.pim || '',
      'Contratto numero': c.contratto?.numero || '',
      'Contratto tipo': c.contratto?.tipo || '',
      'Contratto inizio': c.contratto?.inizio || '',
      'Contratto fine': c.contratto?.fine || '',
      'Ore previste': c.contratto?.ore || '',
      Importo: c.contratto?.importo || '',
      'Accessi attivi': Object.entries(c.accessi || {})
        .filter(([, s]) => (s || '').toLowerCase() === 'sì' || (s || '').toLowerCase() === 'si')
        .map(([r]) => r)
        .join(', '),
      'Da richiedere': Object.entries(c.accessi || {})
        .filter(([, s]) => s === 'Da richiedere')
        .map(([r]) => r)
        .join(', '),
      'Da eliminare': Object.entries(c.accessi || {})
        .filter(([, s]) => s === 'Da eliminare')
        .map(([r]) => r)
        .join(', '),
      'Referenti (count)': (c.referenti || []).length,
      'Documenti (count)': (c.documenti || []).length,
      'Scadenze aperte (count)': (c.scadenze || []).filter((s) => !s.completata).length,
      Note: c.note || ''
    }));
    const wsCli = XLSX.utils.json_to_sheet(cliRows);
    XLSX.utils.book_append_sheet(wb, wsCli, sanitizeSheetName('Clienti'));

    // ===== Foglio 2: Accessi (matrice cliente × risorsa, una riga per accesso) =====
    const accRows = [];
    clients.forEach((c) => {
      Object.entries(c.accessi || {}).forEach(([res, stato]) => {
        const meta = c.accessiMeta?.[res] || {};
        accRows.push({
          Cliente: c.nome,
          Risorsa: res,
          Stato: stato || '',
          Ruoli: (meta.ruoli || []).join(', '),
          Note: meta.note || '',
          'Modificato il': meta.modifiedAt || '',
          'Modificato da': meta.modifiedByName || ''
        });
      });
    });
    const wsAcc = XLSX.utils.json_to_sheet(accRows);
    XLSX.utils.book_append_sheet(wb, wsAcc, sanitizeSheetName('Accessi'));

    // ===== Foglio 3: Scadenze (aperte e chiuse) =====
    const scRows = [];
    clients.forEach((c) => {
      (c.scadenze || []).forEach((s) => {
        const g = typeof daysUntil === 'function' ? daysUntil(s.data) : null;
        scRows.push({
          Cliente: c.nome,
          CPL: c.cpl || '',
          Titolo: s.titolo || '',
          Tipo: s.tipo || '',
          Data: s.data || '',
          'Giorni residui': g == null ? '' : g,
          Stato: s.completata ? 'Completata' : g != null && g < 0 ? 'Scaduta' : 'Aperta',
          Note: s.note || ''
        });
      });
      if (c.contratto?.fine) {
        const g = typeof daysUntil === 'function' ? daysUntil(c.contratto.fine) : null;
        scRows.push({
          Cliente: c.nome,
          CPL: c.cpl || '',
          Titolo: 'Fine contratto',
          Tipo: 'Contratto',
          Data: c.contratto.fine,
          'Giorni residui': g == null ? '' : g,
          Stato: g != null && g < 0 ? 'Scaduto' : 'Aperto',
          Note: c.contratto.numero || ''
        });
      }
    });
    const wsSc = XLSX.utils.json_to_sheet(scRows);
    XLSX.utils.book_append_sheet(wb, wsSc, sanitizeSheetName('Scadenze'));

    // ===== Foglio 4: Referenti =====
    const refRows = [];
    clients.forEach((c) => {
      (c.referenti || []).forEach((r) => {
        refRows.push({
          Cliente: c.nome,
          Nome: r.nome || '',
          Ruolo: r.ruolo || '',
          Email: r.email || '',
          Telefono: r.telefono || '',
          Note: r.note || ''
        });
      });
    });
    if (refRows.length) {
      const wsRef = XLSX.utils.json_to_sheet(refRows);
      XLSX.utils.book_append_sheet(wb, wsRef, sanitizeSheetName('Referenti'));
    }

    const today = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `portale-mase_${today}.xlsx`);
    toast('Export XLSX completato');
    logAudit?.({
      action: 'system',
      entity: 'Export',
      target: 'XLSX',
      details: `Export XLSX: ${clients.length} clienti, ${accRows.length} accessi, ${scRows.length} scadenze`
    });
  } catch (e) {
    console.error(e);
    toast('Errore export XLSX: ' + (e.message || e));
  }
}

// btnExportXLSX vive nella vista "clienti" (lazy): wiring idempotente.
function wireXlsxExport() {
  bindOnce(document.getElementById('btnExportXLSX'), 'click', exportClientiXlsx);
}
document.addEventListener('DOMContentLoaded', wireXlsxExport);
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'clienti') wireXlsxExport();
});

Object.assign(globalThis, { exportClientiXlsx });
export {};
